import type { ServicesResourcesTranslationMessages } from './servicesResourcesTranslationMessages';

export const servicesResourcesLanguageItalian: ServicesResourcesTranslationMessages = {
  soundfiles: {
    name: 'File audio',
    description: 'Visualizza e gestisci i file audio',
    fields: {
      id: 'ID',
      description: 'Descrizione',
      fileUploadHint: `Trascina il file audio o clicca per selezionarlo.
      File accettati: .mp3, .wav`,
      name: 'Nome file',
      labels: { id: 'Etichette', name: 'Etichette' },
    },
    errors: {
      fileInvalid: 'Il formato del file non è valido',
      fileTooBig: 'La dimensione del file è troppo grande',
      fileNotFound: 'File audio non trovato, si prega di riprovare',
      generic: 'Errore durante il caricamento, si prega si riprovare',
    },
    operations: {
      create: 'Carica file audio',
      delete: 'Elimina il file audio',
      edit: 'Modifica file audio',
      sections: {
        details: 'Info file audio',
      },
    },
    serviceButtonLabel: 'Gestisci',
  },
};
